import LinkButton from '../../../../common/components/Link/LinkButton.js'
import {returnOrderReferenceIDsSelector} from '../../../../data/orders.js'
import {useSelector} from '../../../../store.js'

export default function LinkedRMAList({orderNumber}) {
  const referenceIDs = useSelector((state) =>
    returnOrderReferenceIDsSelector(state, {orderNumber}),
  )

  if (referenceIDs.length === 0) {
    return null
  }

  return (
    <>
      <h4 className="list__title--order-data margin-bottom-3">
        Associated RMA<span className="lowercase">s</span>
      </h4>
      <ul className="list square margin-bottom-5">
        {referenceIDs.map((referenceID) => (
          <li className="list__item fs-n1 margin-bottom-1" key={referenceID}>
            <LinkButton
              className="darker"
              title={`Navigate to ${referenceID} detail page`}
              href={`#/rma/${encodeURIComponent(referenceID)}`}
            >
              {referenceID}
            </LinkButton>
          </li>
        ))}
      </ul>
    </>
  )
}
